const SearchBox = ({
  placeholder,
  translations,
  debounceMs,
  algoliaIndexName,
  algoliaApplicationId,
  algoliaSearchApiKey,
  searchUrl
}) => ({
  init() {
    (async () => {
      // await import('instantsearch.css/themes/satellite.css');
      await import('../_ais-instantsearch.scss');

      const { default: algoliasearch } = await import('algoliasearch/lite');
      const { default: instantsearch } = await import('instantsearch.js');
      const {
        configure,
        infiniteHits,
        clearRefinements,
        hierarchicalMenu,
        searchBox
      } = await import('instantsearch.js/es/widgets');

      const searchClient = algoliasearch(
        algoliaApplicationId,
        algoliaSearchApiKey
      );

      const search = instantsearch({
        indexName: algoliaIndexName,
        searchClient,
        insights: true,
        routing: true
      });

      let timerId;

      search.addWidgets([
        searchBox({
          container: '#searchbox',
          placeholder,
          cssClasses: {
            form: 'typo-copy'
          },
          queryHook(query, refine) {
            window.clearTimeout(timerId);
            timerId = window.setTimeout(() => refine(query), debounceMs);
          }
        }),
        infiniteHits({
          container: '#hits',
          cssClasses: {
            loadMore: 'button button--primary'
          },
          templates: {
            showMoreText: (data, { html }) => html`
              <span class="button__label typo-copy">
                ${translations.loadMore}
              </span>
            `,
            empty: (results, { html }) => html`
              <div class="jumbotron">
                <svg
                  class="icon icon--HdkLogoSmall"
                  viewBox="0 0 38 20"
                  role="img"
                >
                  <g>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 1.831V.47h.137C28.63.469 37 8.699 37 18.852v.136h-1.386l.001-.135c0-9.401-7.75-17.022-17.308-17.022h-.137Z"
                    />
                    <path
                      d="M18.17 1.831h-.051v.052h.051V1.83Zm0-1.362V.42h-.051v.05h.05ZM37 18.99v.05h.05v-.05H37Zm-1.386 0h-.05l-.001.05h.051v-.05ZM18.221 1.83V.47h-.102v1.362h.102Zm-.05-1.31.136-.001V.418h-.137V.52Zm.136-.001c10.296 0 18.641 8.208 18.641 18.332h.103C37.05 8.67 28.658.418 18.307.418V.52Zm18.641 18.332v.136h.102v-.136h-.102Zm.051.085h-1.385v.103H37v-.103Zm-1.333.052v-.136h-.102v.135h.102Zm0-.136c0-9.43-7.773-17.073-17.36-17.073v.102c9.532 0 17.258 7.599 17.258 16.97h.102ZM18.306 1.78h-.137l.001.103.137-.001V1.78Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 3.19c-8.73.073-15.785 7.056-15.785 15.66v.136H1.001L1 18.849C1 9.494 8.675 1.901 18.17 1.83V3.19Z"
                    />
                    <path
                      d="M18.17 3.19v.051h.051v-.05h-.051ZM2.385 18.986v.051h.052v-.052h-.052Zm-1.384 0H.949v.051h.052v-.051ZM18.17 1.828h.051v-.051h-.051v.051Zm0 1.311c-8.758.073-15.836 7.078-15.836 15.71h.102c0-8.574 7.031-15.535 15.735-15.608l-.001-.102ZM2.334 18.85v.137h.103l-.001-.136h-.102Zm.051.086H1.001v.102h1.384v-.102Zm-1.333.05v-.136H.948v.137h.103Zm0-.136c0-9.326 7.65-16.897 17.118-16.97v-.102C8.647 1.85.949 9.465.949 18.849h.102ZM18.221 3.19V1.828h-.103V3.19h.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 4.55V3.188h.136c8.794 0 15.923 7.01 15.923 15.66v.136h-1.385v-.136c0-7.897-6.509-14.298-14.538-14.298h-.136Z"
                    />
                    <path
                      d="M18.17 4.55h-.051v.052h.051V4.55Zm0-1.362v-.051h-.051v.051h.05Zm16.059 15.796v.051h.05v-.05h-.05Zm-1.385 0h-.051v.051h.051v-.05ZM18.221 4.55V3.188h-.102V4.55h.102Zm-.05-1.31.135-.001v-.103h-.137l.001.103Zm.135-.001c8.767 0 15.872 6.989 15.872 15.609h.103c0-8.678-7.153-15.712-15.975-15.712v.103Zm15.872 15.609v.136h.102v-.136h-.102Zm.05.085h-1.384v.102h1.385v-.102Zm-1.333.052.001-.137h-.102l-.001.136h.102Zm.001-.137c0-7.926-6.533-14.35-14.59-14.35v.103c8.002 0 14.488 6.38 14.488 14.247h.102Zm-14.59-14.35-.137.001.001.102h.136v-.103Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.168 7.274V5.913h.138c7.265 0 13.154 5.791 13.154 12.936v.136h-1.385l.001-.137c0-6.392-5.27-11.575-11.77-11.575l-.138.001Z"
                    />
                    <path
                      d="M18.168 7.274h-.051v.052h.052l-.001-.052Zm0-1.361v-.051h-.051v.05h.051ZM31.46 18.985v.052h.05l.001-.051h-.051Zm-1.385 0h-.051v.052h.051v-.052ZM18.22 7.275V5.912h-.102v1.361h.102Zm-.05-1.311h.137V5.86h-.139l.002.103Zm.137 0c7.238 0 13.103 5.77 13.103 12.885h.103c0-7.174-5.913-12.988-13.206-12.988v.102ZM31.41 18.848v.136l.102.001v-.137h-.102Zm.05.085h-1.384v.103h1.385v-.103Zm-1.333.052.001-.138h-.102l-.001.137.102.001Zm.001-.138c0-6.421-5.293-11.626-11.82-11.626v.103c6.472 0 11.718 5.16 11.718 11.523h.102ZM18.307 7.222l-.14.001.002.102h.137v-.103Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.169 5.915c-7.202.073-13.017 5.837-13.017 12.936l.001.135H3.768v-.136c0-7.851 6.435-14.225 14.4-14.297v1.362Z"
                    />
                    <path
                      d="M18.169 5.915v.051h.051v-.05h-.051ZM5.153 18.985v.052h.052v-.052h-.052Zm-1.385 0-.05.001v.05h.05v-.05Zm14.4-14.432h.052V4.5h-.052v.052Zm0 1.311c-7.228.073-13.067 5.859-13.067 12.987h.103c0-7.07 5.791-12.812 12.965-12.885v-.102ZM5.101 18.851v.135h.103v-.135H5.1Zm.052.084H3.768v.102h1.385v-.102Zm-1.334.05v-.134h-.103l.001.135h.102Zm0-.134c0-7.823 6.411-14.175 14.35-14.247v-.102C10.174 4.574 3.715 10.97 3.715 18.85h.103ZM18.22 5.915V4.553h-.102v1.362h.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 8.64V7.277c-6.437.074-11.63 5.228-11.63 11.574v.137h1.385l-.001-.136c0-5.595 4.574-10.139 10.245-10.212Z"
                    />
                    <path
                      d="M18.17 8.64v.051h.05V8.64h-.05Zm0-1.363h.05v-.051h-.051v.051ZM6.54 18.987l-.051.001v.05h.05v-.05Zm1.385 0v.052h.052l-.001-.052h-.051ZM18.22 8.64V7.277h-.103V8.64h.103ZM6.59 18.85c0-6.318 5.17-11.45 11.579-11.522l-.001-.103c-6.463.074-11.681 5.25-11.681 11.625h.102Zm0 .136v-.136h-.103v.137l.103-.001Zm1.334-.05H6.54v.102h1.385v-.103Zm-.052-.085v.136l.103-.001-.001-.135h-.102ZM18.169 8.589c-5.699.073-10.296 4.64-10.296 10.263h.102c0-5.566 4.551-10.088 10.195-10.161l-.001-.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 10V8.638l.136-.001c5.736 0 10.385 4.572 10.385 10.213v.137h-1.386l.002-.137c0-4.888-4.03-8.851-9-8.851h-.137Z"
                    />
                    <path
                      d="M18.17 10h-.051v.052l.052-.001L18.17 10Zm0-1.362v-.052l-.051.001v.05h.05Zm10.52 10.349v.05h.05l.001-.05h-.05Zm-1.385 0-.05-.001-.002.052h.052v-.051ZM18.221 10V8.638h-.102V10h.102Zm-.05-1.311.135-.001v-.102h-.137l.002.103Zm.135-.001c5.708 0 10.334 4.55 10.334 10.162h.102c0-5.67-4.673-10.264-10.436-10.264v.102ZM28.64 18.85l-.001.136.102.001.001-.137h-.102Zm.05.085h-1.385v.103h1.385v-.103Zm-1.333.052v-.137h-.102v.136l.102.001Zm0-.137c0-4.917-4.053-8.902-9.05-8.902v.102c4.943 0 8.948 3.94 8.948 8.8h.103Zm-9.05-8.902h-.138l.002.103.135-.001v-.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 10.002c-4.908.072-8.863 4.007-8.863 8.85v.136h1.386l-.001-.135c0-4.091 3.335-7.416 7.477-7.489v-1.362Z"
                    />
                    <path
                      d="M18.17 10.002h.05V9.95h-.051v.052Zm-8.862 8.986-.051.001v.05h.05v-.05Zm1.385 0v.052h.052l-.001-.052h-.051Zm7.476-7.624.001.051h.05v-.05h-.05Zm-8.811 7.488c0-4.814 3.932-8.727 8.812-8.799l-.002-.102c-4.934.072-8.913 4.03-8.913 8.901h.103Zm0 .136v-.136h-.103c0 .046 0 .092.002.137l.102-.001Zm1.335-.05H9.308v.102h1.385v-.103Zm-.053-.085c0 .045 0 .09.002.136l.102-.002-.001-.134h-.103Zm7.528-7.54c-4.17.073-7.527 3.42-7.527 7.54h.102c0-4.063 3.312-7.366 7.427-7.438l-.002-.102Zm.052.051v-1.362h-.102v1.362h.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.17 12.723v-1.362l.14-.002c4.205 0 7.615 3.354 7.615 7.49 0 .046 0 .092-.002.137H24.54l.001-.137c0-3.384-2.79-6.127-6.23-6.127l-.14.001Z"
                    />
                    <path
                      d="M18.17 12.723h-.051v.052h.052l-.001-.052Zm0-1.362-.001-.052-.05.001v.05h.05Zm7.753 7.625v.051h.05l.002-.05h-.052Zm-1.384 0h-.052v.051h.052v-.05Zm-6.318-6.263v-1.362h-.102v1.362h.102Zm-.05-1.311.138-.002v-.102l-.14.001.002.103Zm.138-.002c4.179 0 7.564 3.332 7.564 7.439h.103c0-4.165-3.433-7.54-7.667-7.54v.102Zm7.564 7.439v.136l.102.002v-.138h-.102Zm.05.086H24.54v.102h1.384v-.102Zm-1.333.052.001-.138h-.102c0 .046 0 .091-.002.136l.103.002Zm.001-.138c0-3.413-2.813-6.179-6.282-6.179v.103c3.414 0 6.18 2.721 6.18 6.076h.102ZM18.31 12.67c-.047 0-.094 0-.14.002l.002.102.138-.001v-.103Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.168 12.723c-3.376.073-6.09 2.788-6.09 6.126 0 .046 0 .092.002.138h1.385a4.458 4.458 0 0 1-.002-.137c0-2.586 2.094-4.691 4.705-4.765v-1.362Z"
                    />
                    <path
                      d="M18.168 12.723h.051v-.053l-.052.002.001.05Zm-6.088 6.264h-.052l.002.05h.05v-.05Zm1.385 0v.05h.053l-.002-.052-.051.002Zm4.703-4.901.002.05h.05v-.05h-.052Zm-6.039 4.763c0-3.31 2.691-6.002 6.04-6.075l-.002-.102c-3.403.074-6.14 2.81-6.14 6.177h.102Zm.002.137a6.208 6.208 0 0 1-.002-.137h-.102c0 .046 0 .093.002.139l.102-.002Zm1.334-.05H12.08v.102h1.385v-.102Zm-.053-.086c0 .046 0 .092.002.138l.102-.003a4.708 4.708 0 0 1-.002-.135h-.102Zm4.755-4.816c-2.639.074-4.755 2.201-4.755 4.816h.102c0-2.558 2.071-4.64 4.655-4.713l-.002-.103Zm.052.051v-1.362h-.102v1.362h.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.168 15.449v-1.363l.14-.002c2.676 0 4.846 2.134 4.846 4.766l-.002.136h-1.386l.003-.135c0-1.88-1.55-3.405-3.461-3.405-.047 0-.094.001-.14.003Z"
                    />
                    <path
                      d="M18.168 15.449h-.051v.053l.053-.002-.002-.051Zm0-1.363-.002-.051-.05.001v.05h.052Zm4.984 4.9v.052h.05v-.05l-.05-.002Zm-1.386 0-.05-.002-.003.053h.053v-.05ZM18.22 15.45v-1.363h-.102v1.363h.102Zm-.05-1.312.138-.002v-.102c-.047 0-.094 0-.14.002l.002.102Zm.138-.002c2.65 0 4.795 2.112 4.795 4.715h.103c0-2.661-2.194-4.817-4.898-4.817v.102Zm4.795 4.715c0 .045 0 .09-.002.135l.103.003.002-.138h-.103Zm.05.085h-1.386v.103h1.386v-.103Zm-1.334.053.002-.137h-.102c0 .044 0 .089-.003.133l.103.004Zm.002-.137c0-1.91-1.573-3.456-3.512-3.456v.102c1.884 0 3.41 1.502 3.41 3.354h.102Zm-3.512-3.456c-.048 0-.095 0-.142.003l.004.102c.046-.002.091-.003.137-.003v-.102Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.168 15.45c-1.847.071-3.322 1.567-3.322 3.4 0 .047 0 .092.002.137h1.387a2.041 2.041 0 0 1-.005-.135c0-1.082.856-1.968 1.938-2.039V15.45Z"
                    />
                    <path
                      d="M18.168 15.45h.05v-.054l-.052.002.002.051Zm-3.32 3.538-.05.002.001.049h.05v-.052Zm1.387 0v.05h.055l-.004-.054-.051.003Zm1.933-2.175.003.052.048-.004v-.048h-.051Zm-3.271 2.038c0-1.806 1.452-3.28 3.273-3.35l-.004-.103c-1.874.073-3.372 1.59-3.372 3.453h.103Zm.003.134a3.346 3.346 0 0 1-.003-.134h-.103l.003.139.103-.005Zm1.335-.049h-1.387v.103h1.387v-.103Zm-.056-.084c0 .046.002.093.005.139l.102-.007a1.94 1.94 0 0 1-.004-.133h-.103Zm1.985-2.09c-1.108.073-1.985.98-1.985 2.09h.103c0-1.055.833-1.919 1.889-1.988l-.007-.102Zm.055.051V15.45h-.103v1.364h.103Z"
                    />
                  </g>
                </svg>
                <div class="richtext">
                  <h3>${translations.noResultsHeadline}</h3>
                  <p
                    dangerouslySetInnerHTML=${{
                      __html: translations.noResultsCopy.replace(
                        '%q%',
                        results.query
                      )
                    }}
                  ></p>
                  <p>
                    <a
                      class="button button--primary"
                      role="button"
                      href="${searchUrl}"
                    >
                      <span class="button__label typo-copy">
                        ${translations.noResultsCTA}
                      </span>
                    </a>
                  </p>
                </div>
              </div>
            `,
            item: (hit, { html, components }) => html`
              <li class="list-item">
                <a class="list-item__link" href="${hit.url}">
                  <div class="list-item__accent"></div>
                  <div>
                    <div class="list-item__title typo-copy">
                      <strong>
                        ${hit.categories.lvl0}:${' '}
                        ${components.Highlight({
                          hit,
                          attribute: 'title'
                        })}
                      </strong>
                    </div>
                    <div class="typo-copy">
                      ${components.Snippet({
                        hit,
                        attribute: 'content'
                      })}
                    </div>
                  </div>
                </a>
              </li>
            `
          }
        }),
        clearRefinements({
          container: '#clear-refinements',
          cssClasses: {
            button: 'button',
            disabledButton: 'button--is-disabled'
          },
          templates: {
            resetLabel: (data, { html }) => html`
              <span class="button__label typo-copy">
                ${translations.clearRefinements}
              </span>
            `
          }
        }),
        hierarchicalMenu({
          container: '#sections-list',
          attributes: ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'],
          limit: 100
        }),
        hierarchicalMenu({
          container: '#dates-list',
          sortBy(a, b) {
            return parseInt(a.name, 10) < parseInt(b.name, 10) ? 1 : -1;
          },
          transformItems(items) {
            return items.map((year) => ({
              ...year,
              data: year.data?.map((month) => {
                const d = new Date();
                d.setMonth(parseInt(month.label, 10) - 1);
                return {
                  ...month,
                  label: d.toLocaleDateString(document.documentElement.lang, {
                    month: 'long'
                  })
                };
              })
            }));
          },
          attributes: [
            'relevantDateCategories.lvl0',
            'relevantDateCategories.lvl1'
          ],
          limit: 100
        }),
        configure({
          hitsPerPage: 8,
          attributesToSnippet: ['content']
        })
      ]);

      search.on('render', () => {
        const noResultsRelated = document.getElementById('no-results-related');

        const hits = document.getElementById('hits');
        const hasNoResults = !!hits.querySelector('.ais-InfiniteHits--empty');

        noResultsRelated.style.display = hasNoResults ? 'block' : 'none';

        const facets = document.querySelectorAll('.ais-HierarchicalMenu');
        facets.forEach((facet) => {
          const isEmpty = facet.classList.contains(
            'ais-HierarchicalMenu--noRefinement'
          );
          const parent = facet.closest('.disclosure');
          parent.style.display = isEmpty ? 'none' : 'block';
        });
      });

      search.start();

      document.querySelector('#searchbox .ais-SearchBox-reset').title =
        translations.reset;
      document.querySelector('#searchbox .ais-SearchBox-submit').title =
        translations.submit;
    })();
  }
});

export default SearchBox;
